import { gql } from "@apollo/client";

export default gql`
  mutation deleteKpiMeasurementMutation($measurementId: Int!) {
    deleteKpiMeasurement(measurementId: $measurementId) {
      ok
    }
  }
`;
